import { merchantState } from './index'

export const setMerchantAttributes = (guid: string) => {
  merchantState.guid = guid
}
